// InventoryForm.js
import React, { useState, useEffect } from 'react';
import api from '../api/api';
import './css/InventoryPage.css';

function InventoryForm({ serialNumber, onClose, onItemAdded }) {
  const [form, setForm] = useState({
    serial_number: serialNumber || '',
    name: '',
    salon: '',
    description: '',
    quantity: 1,
    current_status: 'In Stock',
  });

  useEffect(() => {
    setForm(prev => ({ ...prev, serial_number: serialNumber || '' }));
  }, [serialNumber]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post('/inventory', form);
      onItemAdded(res.data);
    } catch (err) {
      console.error('Error adding item:', err);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="inventory-form">
        <input
          type="text"
          placeholder="Serial Number"
          value={form.serial_number}
          disabled
          onChange={(e) => setForm({ ...form, serial_number: e.target.value })}
        />
        <input
          type="text"
          placeholder="First, Last Name"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
        />
        <input
          type="text"
          placeholder="Salon"
          value={form.salon}
          onChange={(e) => setForm({ ...form, salon: e.target.value })}
        />
        <textarea
          placeholder="Description"
          value={form.description}
          onChange={(e) => setForm({ ...form, description: e.target.value })}
        />
        <input
          type="number"
          placeholder="Quantity"
          value={form.quantity}
          onChange={(e) => setForm({ ...form, quantity: Number(e.target.value) })}
        />
        <button type="submit">Add Item</button>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="cancel"
          >
            Cancel
          </button>
        )}
      </form>
  );
}

export default InventoryForm;
